import React, { useState } from "react";
import { injectIntl } from "react-intl";
import axios from "axios";
import clsx from "clsx";
import { connect, useDispatch } from "react-redux";
import {
  colors,
  IconButton,
  makeStyles,
  Snackbar,
  SnackbarContent,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import Layout from "app/hoc/Layout";
import * as ticketRedux from "../Tickets/_redux/ticketRedux";
import * as auth from "../Auth/_redux/authRedux";
import Ticket from "./components/Ticket";
import VoidTicket from "./modals/VoidTicket";
import UpdateVoidTicket from "./modals/UpdateVoidTicket";
import PayVoidTicket from "./modals/PayVoidTicket";
import Print from "../Tickets/modals/Print";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

function Tickets(props) {
  const useStyles1 = makeStyles((theme) => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.main,
    },
    warning: {
      backgroundColor: amber[700],
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
    },
    message: {
      display: "flex",
      alignItems: "center",
    },
  }));
  const dispatch = useDispatch();

  const [circulationId, setCirculationId] = useState("");
  const [columnPrice, setColumnPrice] = useState("");
  const [ticket, setTicket] = useState({});
  const [price, setPrice] = useState("");
  const [ticketId, setTicketId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [showPayment, setShowPayment] = useState(false);
  const [showPaidWinning, setShowPaidWinning] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("");
  const [barcode, setBarcode] = useState("");
  const [showVoidTicket, setShowVoidTicket] = useState(false);
  const [showUpdateVoidTicket, setShowUpdateVoidTicket] = useState(false);
  const [showPayVoidTicket, setShowPayVoidTicket] = useState(false);

  const handleBarcode = (e) => {
    if (e.target.value.length === 18) {
      setBarcode(e.target.value[17]);
    }
    setBarcode(e.target.value);
    setShowVoidTicket(false);
  };

  const { setPrintData } = ticketRedux.actions;
  const { getProfile } = auth.actions;

  const onTicket = (barcode) => {
    setIsLoading(true);
    axios
      .get(`voidTickets/barcode${barcode ? `?TicketNumber=${barcode}` : ""}`)
      .then(({ data }) => {
        setIsLoading(false);
        setIsError(false);
        setShowVoidTicket(true);
        setTicket(data);
        setTicketId(data.id);
        setPrice(data.price);
        setCirculationId(data.circulationId);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsLoading(false);
          setIsError(true);
          message && setErrMsg(message);
        }
      );
  };

  const getTicketById = (id) => {
    setIsLoading(true);
    axios
      .get(`tickets/byId?id=${id}`)
      .then(({ data }) => {
        dispatch(setPrintData(data));
        setIsLoading(false);
        dispatch(getProfile());
      })
      .catch((err) => {
        err.response.data && console.log(err.response.data);
      });
  };

  const getColumnPrice = (circulationId) => {
    setIsLoading(true);
    return axios.get(`circulations/circulationGames?id=${circulationId}`);
  };

  const putPaidTicket = (ticketNumber) => {
    setIsLoading(true);
    axios
      .put(`voidTickets/paidTicket`, { ticketNumber })
      .then((res) => {
        getTicketById(res.data);
        setSnackbarType("success");
        setSnackbarMessage("Ödəniş uğurla həyata keçirildi!");
        props.requestUser();
        setIsLoading(false);
        setShowPayVoidTicket(false);
        setShowVoidTicket(false);
        setTicketId(res.data);
        setShowPrint(true);
      })
      .catch(
        ({
          response: {
            data: { message },
            status,
          },
        }) => {
          setSnackbarType("error");
          if (message === "Your balance is not enough.") {
            setSnackbarMessage("Balansınızda kifayət qədər vəsait yoxdur.");
          } else if (status === 401) {
            setSnackbarMessage("İstifadəçinin autentifikasiyası yoxdur.");
          } else {
            setSnackbarMessage(message);
          }

          handleClick();
          setIsLoading(false);
          setShowPaidWinning(false);
        }
      );
  };

  function MySnackbarContentWrapper(props) {
    const classes = useStyles1();
    const { className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
      <SnackbarContent
        className={clsx(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
  }

  const [open, setOpen] = React.useState(false);

  function handleClick() {
    setOpen(true);
  }

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  }

  const { amber, green } = colors;

  return (
    <Layout>
      <Ticket
        onTicket={onTicket}
        ticket={ticket}
        barcode={barcode}
        onBarcode={handleBarcode}
        isLoading={isLoading}
        setShowPayment={setShowPayment}
        setShowPaidWinning={setShowPaidWinning}
        setShowEdit={setShowEdit}
        isError={isError}
        errMsg={errMsg}
      />
      {showVoidTicket && (
        <VoidTicket
          show={showVoidTicket}
          onHide={setShowVoidTicket}
          data={ticket}
          setShowUpdateVoidTicket={setShowUpdateVoidTicket}
          setIsLoading={setIsLoading}
          setColumnPrice={setColumnPrice}
          circulationId={circulationId}
          getColumnPrice={getColumnPrice}
          price={price}
          setShowPayVoidTicket={setShowPayVoidTicket}
        />
      )}
      {showUpdateVoidTicket && (
        <UpdateVoidTicket
          show={showUpdateVoidTicket}
          onHide={setShowUpdateVoidTicket}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          barcode={barcode}
          id={ticketId}
          columnPrice={columnPrice}
          onTicket={onTicket}
          setBarcode={setBarcode}
          setTicket={setTicket}
        />
      )}
      {showPayVoidTicket && (
        <PayVoidTicket
          show={showPayVoidTicket}
          onHide={setShowPayVoidTicket}
          barcode={barcode}
          putPaidTicket={putPaidTicket}
        />
      )}
      {showPrint && <Print show={showPrint} onHide={setShowPrint} />}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackbarType}
          message={snackbarMessage}
        />
      </Snackbar>
    </Layout>
  );
}

export default injectIntl(connect(null, auth.actions)(Tickets));
